import { useParams, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import Markdown from 'markdown-to-jsx'

/* Format de date arabe libanais déterministe — « 19 أيار 2026 · 14:23 » */
const LEBANESE_MONTHS = [
  'كانون الثاني', 'شباط', 'آذار', 'نيسان', 'أيار', 'حزيران',
  'تموز', 'آب', 'أيلول', 'تشرين الأول', 'تشرين الثاني', 'كانون الأول',
]

const formatFullDate = (iso) => {
  if (!iso) return ''
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ''
  const day = d.getDate()
  const month = LEBANESE_MONTHS[d.getMonth()] || ''
  const year = d.getFullYear()
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  return `${day} ${month} ${year} · ${hh}:${mm}`
}

const Post = ({ entries = [] }) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [entry] = useState(entries.find((e) => e.slug === id))

  if (!entry) {
    return (
      <div className="container container--narrow">
        <p className="flash-loading" role="status">جارٍ التحميل…</p>
      </div>
    )
  }

  const shareOnFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`
    window.open(url, '_blank', 'width=600,height=400')
  }
  const shareOnTwitter = () => {
    const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(entry.title)}`
    window.open(url, '_blank', 'width=600,height=400')
  }
  const shareOnWhatsApp = () => {
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(window.location.href)}`
    window.open(url, '_blank')
  }

  return (
    <div className="container container--narrow">
      <div className="post__back-row">
        <button
          type="button"
          className="btn btn--ghost"
          onClick={() => navigate('/')}
        >
          ← العودة إلى الفلاش
        </button>
      </div>

      <article className="post">
        <p className="post__time">{formatFullDate(entry.date)}</p>
        <h1 className="post__title">{entry.title}</h1>
        <div className="post__body">
          <Markdown>{entry.body}</Markdown>
        </div>

        <div className="post__share" aria-label="مشاركة">
          <button
            type="button"
            className="post__share-btn post__share-btn--facebook"
            onClick={shareOnFacebook}
          >
            مشاركة على فيسبوك
          </button>
          <button
            type="button"
            className="post__share-btn post__share-btn--twitter"
            onClick={shareOnTwitter}
          >
            مشاركة على تويتر
          </button>
          <button
            type="button"
            className="post__share-btn post__share-btn--whatsapp"
            onClick={shareOnWhatsApp}
          >
            مشاركة على واتساب
          </button>
        </div>
      </article>
    </div>
  )
}

export default Post
